// extracted by mini-css-extract-plugin
module.exports = {"VisionStatement":"styles_VisionStatement__zRTbd","outer":"styles_outer__L7OPO","inner":"styles_inner__dr00u"};